var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center gap-1.5",class:_vm.textColor},[_c('ZIcon',{attrs:{"icon":_vm.icon,"size":"x-small","color":"current"}}),_vm._v(" "),_c('div',{staticClass:"text-xs leading-none"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }